import { FuelFillingCardState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
const initialState: FuelFillingCardState = {
  count: 0,
  refresh: 0,
  loading: true,
  current_filters: {},
  sorting: [],
  refreshLoader: false,
  pagination: { pageIndex: 0, pageSize: 10 },
  filters: [],
};

export const fuelFillingCardSlice = createSlice({
  name: "fuelFillingCard",
  initialState,
  reducers: {
    setPagination: (state, action: PayloadAction<any>) => {
      state.pagination = action.payload;
    },
    refresh: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
    },

    setFilters: (state, action) => {
      state.filters = action.payload;
      state.refreshLoader = true;
    },
    setSorting: (state, action) => {
      state.sorting = action.payload;
      state.refreshLoader = true;
    },
    setCurrentFilters: (state, action) => {
      state.current_filters = action.payload;
    },
    resetFilters: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filters = initialState.filters;
      state.current_filters = initialState.current_filters;
      state.sorting = initialState.sorting;
    },
  },
});

const fuelFillingCardReducer = fuelFillingCardSlice.reducer;

export const fuelFillingCardActions = fuelFillingCardSlice.actions;
export default fuelFillingCardReducer;
